export default __webpack_public_path__ + "static/media/customers.85c20fda.png";